/**
 * routePaths — every non-screen URL the Console serves, in one place.
 *
 * The authenticated screens are NOT here: those derive from the screen registry
 * (`consoleScreens.js` `pathForScreen`), because their id and their path are the
 * same fact. These are the paths that have no screen id behind them.
 *
 * One module because three files have to agree on them — `App.jsx` matches them,
 * `useAuth.js` navigates to them, `useCardStep.js` reads and scrubs them — and a
 * literal that drifts in one of the three fails silently: a route that no longer
 * matches renders the catch-all redirect, which looks like a working app that just
 * went to the wrong place.
 *
 * THE FIVE LANDING PATHS ARE NOT OURS TO RENAME. The backend mints `/verify-email`
 * (L01), `/reset-password` (F14) and `/account-closure` (A13) into emails that are
 * already sent, and Stripe is configured with the two `/registration` returns
 * (`backend/app/routes/payment_setup.py` `_return_urls`). Changing a value here
 * breaks links in inboxes we cannot reach and a provider config this repo does not
 * own. The three auth-screen paths below are ours and carry no such constraint.
 *
 * A SIXTH externally minted path exists and is deliberately NOT here: `/billing/credit`,
 * E21's Stripe credit top-up return (`backend/app/core/services/credit_topup.py`). It is
 * not a landing, it is a deep link into the Billing SCREEN, so it lives on that screen's
 * registry entry in `consoleScreens.js` where its route is declared. It is named here only
 * because "the externally minted paths are in routePaths.js" is the obvious wrong inference
 * from this file, and acting on it is how the path came to be unrouted in the first place.
 */

export const ROUTES = {
  // Ours: the unauthenticated screens. These replaced the `authView` state machine,
  // so each is now a real URL rather than a string in a useState.
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",

  // Minted by the backend into emails — see the warning above.
  verifyEmail: "/verify-email",
  resetPassword: "/reset-password",
  accountClosure: "/account-closure",

  // Minted by Stripe as the two setup-session return URLs — see the warning above.
  registrationCard: "/registration/card",
  registrationComplete: "/registration/complete",

  root: "/",
};
